"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runReaction = exports.getAutoObservable = exports.createObservable = exports.autorun = void 0;
var reactiveState_1 = require("./reactiveState");
Object.defineProperty(exports, "autorun", { enumerable: true, get: function () { return reactiveState_1.autorun; } });
Object.defineProperty(exports, "createObservable", { enumerable: true, get: function () { return reactiveState_1.createObservable; } });
Object.defineProperty(exports, "getAutoObservable", { enumerable: true, get: function () { return reactiveState_1.getAutoObservable; } });
Object.defineProperty(exports, "runReaction", { enumerable: true, get: function () { return reactiveState_1.runReaction; } });
//# sourceMappingURL=index.js.map